<template>
    <div v-if="visible" class="novedad-highlight">
        <span v-if="etiqueta" class="novedad-highlight-etiqueta">{{ etiqueta }}</span>
        <slot />
    </div>
    <div v-else class="novedad-highlight-apagado">
        <slot />
    </div>
</template>

<script>
/**
 * Señala una sección nueva (tarjeta, entrada de lista) de forma sobria: una
 * banda de acento en el borde izquierdo, un fondo apenas teñido y una etiqueta
 * discreta arriba a la derecha. Sin animaciones ni brillos.
 *
 * Uso:
 *   <novedad-highlight :etiqueta="$t('nuevo')" hasta="2026-12-31">
 *       <router-link :to="{ name: 'cierre-caja-z' }"><li>…</li></router-link>
 *   </novedad-highlight>
 *
 * - `hasta` (AAAA-MM-DD): a partir de ese día deja de señalarse solo, sin tocar
 *   código. Sin `hasta`, se señala mientras `activo` sea true.
 */
export default {
    name: "NovedadHighlight",

    props: {
        activo: { type: Boolean, default: true },
        etiqueta: { type: String, default: "" },
        hasta: { type: String, default: "" },
    },

    computed: {
        visible() {
            if (!this.activo) return false;
            if (!this.hasta) return true;
            const hoy = new Date();
            const limite = new Date(this.hasta + "T23:59:59");
            return isNaN(limite.getTime()) ? true : hoy <= limite;
        },
    },
};
</script>

<style>
/* Sin scoped: el contenido llega por slot y el estilo se aplica al <li> hijo. */
.novedad-highlight {
    position: relative;
    display: block;
}

/* Banda de acento por dentro (box-shadow inset) para no mover el texto respecto al resto de la
   lista; el hover lo sigue dando la propia lista (.list-files a li:hover), como en las demás entradas. */
.novedad-highlight li {
    background-color: #f3fafa;
    box-shadow: inset 3px 0 0 #00A3AD;
    padding-right: 90px; /* hueco para la etiqueta */
}

.novedad-highlight-etiqueta {
    position: absolute;
    top: 10px;
    right: 12px;
    z-index: 1;
    background: #fff;
    color: #00838b;
    border: 1px solid #00A3AD;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1;
    padding: 3px 7px;
    border-radius: 3px;
    pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Novedad/NovedadHighlight.vue